import protoRoot from "../proto-root";
import DataSenderStationConfiguration from "../private/DataSenderStationConfiguration";
import BabyStationState from "../private/BabyStationState";

const name = "startMonitoringRPCResponse";

function create({
  senderStationConfiguration,
  resultCode,
  monitoringTime,
  monitoringId,
  unlimitedTimeMonitoring,
  babyStationState
}) {
  const StartMonitoringRPCResponse = protoRoot.lookupType(
    "comm.StartMonitoringRPCResponse"
  );
  const StartRPCResultCode = protoRoot.lookupEnum("comm.StartRPCResultCode");
  const babyStationStateCreated = BabyStationState.create(babyStationState);

  const payload = {
    senderStationConfiguration: DataSenderStationConfiguration.create(
      senderStationConfiguration
    ),
    resultCode: StartRPCResultCode.values[resultCode],
    monitoringTime,
    monitoringId,
    unlimitedTimeMonitoring,
    babyStationState: babyStationStateCreated,
    // obsolete, keep it for compatibility
    lastNoise: babyStationStateCreated.lastNoise,
    remoteSettings: babyStationStateCreated.remoteSettings,
    batteryStatus: babyStationStateCreated.batteryStatus
  };

  const Response = StartMonitoringRPCResponse.create(payload);
  return { payload: Response, name, sendBy: "xmpp" };
}

export default {
  create,
  name
};
